
      var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 55.407,
  cy: 69.139,
  r: 3,
  fill: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M88.002 48.787h-2.033a2 2 0 0 0-2 2v8.583a2 2 0 0 0 2 2h21.327a2 2 0 0 0 2-2v-8.583a2 2 0 0 0-2-2h-2.356m-16.938 0v-4.292a2 2 0 0 1 2-2h.42m-2.42 6.292h16.938m0 0v-4.292a2 2 0 0 0-2-2h-.42m0 0V26.363m0 16.132h-6.033m0 0V26.363m0 16.132H90.42m0 0V26.363",
  stroke: "#090909",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.782 63.628c3.549-3.496 12.646-8.389 20.648 0M39.168 57.98c5.646-6.452 20.23-13.808 34.038 0",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M101.451 62.165a44.794 44.794 0 0 1-27.038 38.952 44.801 44.801 0 1 1-26.351-85.11c2.035-.4 4.102 1.195 4.239 3.696.127 2.323-1.711 4.587-4.459 5.283a36.086 36.086 0 1 0 44.88 37.18h8.729z",
  stroke: "#000",
  strokeWidth: 4.4
})));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <circle cx=\"55.407\" cy=\"69.139\" r=\"3\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M88.002 48.787h-2.033a2 2 0 0 0-2 2v8.583a2 2 0 0 0 2 2h21.327a2 2 0 0 0 2-2v-8.583a2 2 0 0 0-2-2h-2.356m-16.938 0v-4.292a2 2 0 0 1 2-2h.42m-2.42 6.292h16.938m0 0v-4.292a2 2 0 0 0-2-2h-.42m0 0V26.363m0 16.132h-6.033m0 0V26.363m0 16.132H90.42m0 0V26.363\" stroke=\"#090909\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n    <path d=\"M45.782 63.628c3.549-3.496 12.646-8.389 20.648 0M39.168 57.98c5.646-6.452 20.23-13.808 34.038 0\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n    <path d=\"M101.451 62.165a44.794 44.794 0 0 1-27.038 38.952 44.801 44.801 0 1 1-26.351-85.11c2.035-.4 4.102 1.195 4.239 3.696.127 2.323-1.711 4.587-4.459 5.283a36.086 36.086 0 1 0 44.88 37.18h8.729z\" stroke=\"#000\" stroke-width=\"4.4\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/wifi.f4e9e10ae3cf032394b015172867540b.svg"),
        {
          React: SvgWifi,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      